import Model, { attr } from '@ember-data/model';

export default class HomeawayConnectionModel extends Model {
  @attr('string') accountName!: string;
  @attr('boolean') autoNewListingPromotion!: boolean;
  @attr('number') newListingPromotionPercentage!: number;
  @attr('string') status?: string | null;
  @attr('string') companyName?: string | null;
  @attr('string') externalAdvertiserId?: string | null;

  get isPublishable(): boolean {
    return !this.status || this.status === 'active';
  }

  get displayName(): string {
    const companyName = this.companyName?.trim();

    if (!companyName) {
      return this.accountName;
    }

    const advertiserId = this.externalAdvertiserId || this.accountName;

    return advertiserId ? `${companyName} (${advertiserId})` : companyName;
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'homeaway-connection': HomeawayConnectionModel;
  }
}
